(function (ws) {
    'use strict';

    ws.views.cartTableRow = ws.views.googleAnalytics.extend({

        tagName: 'tr',

        events: {
            'keydown input.qup-qty': 'blurOnEnter',
            'change input.qup-qty': 'updateQty',
            'focus input.qup-qty': 'saveLastQuantityValue'
        },

        ENTER_KEY: 13,

        /**
         * Initialize
         */
        initialize: function (options) {

            // Override values from parent googleAnalatics view
            this.TYPE_ADD_CHANGE_QUANTITY = (options.addChangeQuantity) ? options.addChangeQuantity : this.TYPE_ADD_CHANGE_QUANTITY;
            this.TYPE_REMOVE_CHANGE_QUANTITY = (options.removeChangeQuantity) ? options.removeChangeQuantity : this.TYPE_REMOVE_CHANGE_QUANTITY;
            this.TYPE_REMOVE_REMOVE_PRODUCT = (options.removeProduct) ? options.removeProduct : this.TYPE_REMOVE_REMOVE_PRODUCT;
            this.TYPE_REMOVE_CLEAR_CART = (options.clearCart) ? options.clearCart : this.TYPE_REMOVE_CLEAR_CART;

            this.template = _.template($('#product-table-row').html());
            this.$table = this.$('#comp-qut-table');
            this.$errors = this.$('.qup-cart-errors');
            this.$apiError = $('.api-error-message'); //parent api error message
            this.model.on('change:qty', this.render, this);
            this.lastQtyInput = null;

            this.currencyCode = $('#page').data('currency-iso-code');
            this.$gaTrackingId = $('#gaTrackingId');
            this.pageName = $('.pageName').val();

            this.listenTo(this.model, 'sync', this.render);

            this.render();

            ws.views.googleAnalytics.prototype.initialize.call(this);
            setTimeout(() => {
                this.renderToolTips();
            }, 100);
        },

        /**
         * Render
         */
        render: function () {
            this.$el.html(this.template(this.model.toJSON()));
            this.$tooltips = this.$('[data-view="tooltipModal"]');
            this.$qtyInput = this.$('input.qup-qty');

            return this;
        },

        /**
         * Render Tooltips
         */
        renderToolTips: function () {
            this.$tooltips.each(function ($el) {
                new ws.views.tooltipModal({
                    el: $el
                });
            });
        },

        /**
         * Lose the focus of the element if the `Enter` key was pressed.
         * @param {Object} e
         */
        blurOnEnter: function (e) {
            var keyCode = e.keyCode;
            var $el = $(e.currentTarget);

            if (keyCode === this.ENTER_KEY) {
                $el.blur();
                e.preventDefault();
            }
        },

        /**
         * Save last quantity value for analytics
         * @param {Object} e
         */
        saveLastQuantityValue: function (e) {
            var $el = $(e.currentTarget);
            this.lastQtyInput = $el.val();
        },

        /**
         * Update Quantity
         * @param {Object} e
         */
        updateQty: function (e) {
            this.$apiError.hide();
            this.eventAgg.trigger('removeTooltipView');
            this.$errors.hide();
            var $el = $(e.currentTarget);

            if (this.model) {
                var qty = $el.val();

                if (qty > 0 && Number(qty) === Math.round(qty)) {
                    this.model.set({
                        quantity: qty
                    });

                    let parentElement = $el.closest('tr');
                    let productInfo = parentElement.find('td.delete');
                    let productName = productInfo.data('name');
                    let idProduct = productInfo.data('id');
                    let partNo = productInfo.data('partno');
                    let quantity = this.$qtyInput.val();
                    let price = productInfo.data('price');
                    let brand = productInfo.data('brand');
                    let categories = productInfo.data('category');

                    if (categories !== 'notPresent') {
                        categories = this.mapCategoryNamesToArray(categories);
                    }

                    var gaTrackingId = this.$gaTrackingId.val();

                    dataLayerAA.cart = {};

                    if (this.pageName == 'quotecartpage') {
                        dataLayerAA.cart.category = 'quote';
                    } else if (this.pageName == 'cartPage') {
                        dataLayerAA.cart.category = 'cart';
                    }

                    dataLayerAA.product = [];

                    if (qty > Number(this.lastQtyInput)) {
                        this.gtmAddToCart(this.TYPE_ADD_CHANGE_QUANTITY, productName, idProduct, quantity, price.toString(), brand, categories, this.currencyCode, gaTrackingId);
                        dataLayerAA.cart.type = 'add';
                        dataLayerAA.cart.action = 'increase quantity';

                    } else if (qty < Number(this.lastQtyInput)) {
                        this.gtmRemoveFromCart(this.TYPE_REMOVE_CHANGE_QUANTITY, productName, idProduct, quantity, price.toString(), gaTrackingId, brand, categories);
                        dataLayerAA.cart.type = 'remove';
                        dataLayerAA.cart.action = 'decrease quantity';
                    }

                    let product = {};
                    product.name = productName;
                    product.id = partNo;
                    product.price = price;
                    product.category = categories;
                    product.vendor = brand;
                    product.quantity = quantity;
                    dataLayerAA.product.push(product);
                    _satellite.track('event:cart');

                    setTimeout(function () {
                        this.$qtyInput.prop('disabled', true);
                    }.bind(this), 0);

                    this.model.save().done(function (response) {
                        this.$qtyInput.prop('disabled', false);
                        this.eventAgg.trigger('updateCart');
                        this.eventAgg.trigger('crt-updateCartTotal', response.cartTotal);
                        $('.crt-spinner').show();
                        this.eventAgg.trigger('refreshProductCartWithOutWarning');
                    }.bind(this)).fail(function() {
                        this.$qtyInput.prop('disabled', false);
                        this.$apiError.show();
                        $('.crt-spinner').hide();
                    }.bind(this));
                } else {
                    $el.val(this.model.get('quantity'));
                }
            }
        },

        /**
         * transform category names to mapped array to use in analytics
         * @param {string} categoryNames
         */
        mapCategoryNamesToArray: function(categoryNames) {
            var categoryNamesArray = categoryNames.split(',');
            var categoryObjectArray = [];

            _.each(categoryNamesArray, function(category) {
                categoryObjectArray.push(category.replace(/\W/g, ''));
            });

            return categoryObjectArray;
        }
    });

})(westcon);
